import {
  CheckForUnderstandingQuizAttachment,
  ICheckForUnderstandingQuizLevel,
} from "@/types/models/CheckForUnderstandingQuiz.interface";

function getChecksForUnderstandingLevelMatch(
  checksForUnderstandingAttachment:
    | CheckForUnderstandingQuizAttachment
    | undefined,
  currentArticleLevelId: string,
): ICheckForUnderstandingQuizLevel | undefined {
  if (checksForUnderstandingAttachment?.data?.levels?.length) {
    const levels = checksForUnderstandingAttachment.data.levels;
    return levels.find(
      (level) => level.article_level_id === currentArticleLevelId,
    );
  }
  return undefined;
}

export default getChecksForUnderstandingLevelMatch;
